import { createContext } from 'react';

export const SettingsContext = createContext(null);